import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Duration } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { Error } from '@root/shared'

import { preparePermitInstructionsRequestAction } from './swap-requests'

import type { TypeHelper } from '@blade/std-lib'
import type { TradePreparePermitInstructionsCreatePayload as TradePreparePermitInstructionsCreatePayloadDto } from '@blade/trade-api-client'
import type { CurrencyAddress } from '@root/entities/currency'
import type { WalletAddress, WalletId } from '@root/entities/wallet'

interface TradePreparePermitInstructionsCreatePayload
  extends TypeHelper.OmitKey<
    TradePreparePermitInstructionsCreatePayloadDto,
    'walletId' | 'walletAddress' | 'tokenAddress' | 'deadlineMs'
  > {
  walletId: WalletId
  walletAddress: WalletAddress
  tokenAddress: CurrencyAddress
  deadline: Duration.Duration
}

export const prepareAndSignPermitAction = action(
  async (ctx, req: TradePreparePermitInstructionsCreatePayload) => {
    const { secureStorageService } = ctx.get(dependenciesAtom)
    const permitResult = await ctx.schedule(() =>
      preparePermitInstructionsRequestAction(ctx, {
        ...req,
        deadlineMs: Duration.toMillis(req.deadline),
      }),
    )

    if (Result.isFailure(permitResult)) {
      return Result.fail(permitResult.failure)
    }

    const signedPermitResult = await ctx.schedule(() =>
      secureStorageService.signPermit({
        walletId: req.walletId,
        permitData: permitResult.success.serializedPermit,
      }),
    )

    if (Result.isFailure(signedPermitResult)) {
      return Result.fail(
        Error.UnknownError.fromUnknown(signedPermitResult.failure),
      )
    }
    return Result.succeed({
      permitSingle: permitResult.success.permitSingle,
      signedPermit: signedPermitResult.success.signature,
    })
  },
  'prepareAndSignPermitAction',
)
